import { useLocation } from 'react-router-dom';

const AdminFooter = () => {
  const location = useLocation();
  const isDashboardPath = location?.pathname === '/dashboard/';
  const year = new Date().getFullYear();

  return (
    <>
      {isDashboardPath && (
        <footer
          style={{
            padding: '1rem',
          }}
        >
          © {year} Autonomous Technology. All rights reserved.
        </footer>
      )}
    </>
  );
};

export default AdminFooter;
